<template>
  <section
    :class="{
      'section-builder-resource cards': true,
    }"
  >
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'container mx-auto': true,
        }"
      >
        <div
          v-if="ResourceCardAtom"
          :class="{
            'text-center': true,
          }"
        >
          <PortableText
            v-if="ResourceCardAtom.heading?.standardPortableText"
            :portable-data="ResourceCardAtom.heading.standardPortableText"
            :class="{
              'mx-auto mb-12 max-w-[928px]': true,
            }"
          />
        </div>
        <div
          v-if="ResourceCardAtom?.cards"
          :class="{
            'grid grid-cols-12 gap-4': true,
          }"
        >
          <template
            v-for="(card, index) in ResourceCardAtom?.cards"
            :key="index"
          >
            <ReferenceCardGrid
              v-if="card._type === 'referenceCard'"
              v-bind="card"
            />
            <ManualCard
              v-else-if="card._type === 'manualCard'"
              v-bind="card"
              :class="{
                'col-span-12 md:col-span-6 lg:col-span-4': true,
              }"
            />
          </template>
        </div>
      </div>
    </GeneralTheme>
  </section>
</template>
<script setup lang="ts">
import type { SectionBuilderResourceCard } from '~/sanity/types';
import GeneralTheme from '../Themes/GeneralTheme.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import ReferenceCardGrid from '~/components/Molecules/ReferenceCard/ReferenceCardGrid.vue';
import ManualCard from '~/components/Atmos/ManualCard/ManualCard.vue';

defineProps<SectionBuilderResourceCard>();
</script>

<style lang="scss" scoped></style>
